<template>
  <div class="shopping">
    <div class="shopping-t com-title">积分商城</div>
    <div class="banan">
      <div class="wrapper1" v-if="this.list.length === 0">
        <div class="bar-img1">
          <img src="../../assets/images/c_banner.png"/>
        </div>
      </div>
      <div class="swiper-container1" v-else>
        <div class="wrapper1">
          <swiper :options="swiperOption1">
            <swiper-slide>
              <div class="bar-img1">
                <img src="../../assets/images/c_banner.png" alt="">
              </div>
            </swiper-slide>
            <swiper-slide v-for="item in list" :key="$index">
              <div class="bar-img1">
                <template v-if="item.linkUrl.substring(0, 4) === 'http'">
                  <a :href="item.linkUrl" target="_blank" style="display: block;width: 100%;height: 100%">
                    <img :src="item.picUrl" alt="">
                  </a>
                </template>
                <template v-else>
                  <a :href="'http://' + item.linkUrl" target="_blank" style="display: block;width: 100%;height: 100%">
                    <img :src="item.picUrl" alt="">
                  </a>
                </template>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="swiper-pagination1"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <div class="wrap" v-if="this.lpzx !== null && this.lpzx !== undefined && this.lpzx.length !== 0">
      <div class="title">精美礼品</div>
      <div class="content">
        <ul>
          <template v-for="item in lpzx">
            <li>
              <router-link class="deta" :to="{path:'/shopping-details', query:{id: item.id}}">
                <div class="pic">
                  <img :src="item.productPics"/>
                </div>
                <div class="con">{{item.title}}</div>
                <div class="pri">
                  <div>{{item.exchangeScore}}积分</div>
                  <div>热门</div>
                </div>
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="wrap" v-if="this.zszt !== null && this.zszt !== undefined && this.zszt.length !== 0">
      <div class="title">智投营销工具</div>
      <div class="content">
        <ul>
          <template v-for="item in zszt">
            <li>
              <router-link class="deta" :to="{path:'/shopping-details', query:{id: item.id}}">
                <div class="pic">
                  <img :src="item.productPics"/>
                </div>
                <div class="con">{{item.title}}</div>
                <div class="pri">
                  <div>{{item.exchangeScore}}积分</div>
                  <div>热门</div>
                </div>
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="wrap" v-if="this.sqcy !== null && this.sqcy !== undefined && this.sqcy.length !== 0">
      <div class="title">品牌营销工具</div>
      <div class="content">
        <ul>
          <template v-for="item in sqcy">
            <li>
              <router-link class="deta" :to="{path:'/shopping-details', query:{id: item.id}}">
                <div class="pic">
                  <img :src="item.productPics"/>
                </div>
                <div class="con">{{item.title}}</div>
                <div class="pri">
                  <div>{{item.exchangeScore}}积分</div>
                  <div>热门</div>
                </div>
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="wrap" style="border: none" v-if="this.wjqm !== null && this.wjqm !== undefined && this.wjqm.length !== 0">
      <div class="title">媒体营销工具</div>
      <div class="content">
        <ul>
          <template v-for="item in wjqm">
            <li>
              <router-link class="deta" :to="{path:'/shopping-details', query:{id: item.id}}">
                <div class="pic">
                  <img :src="item.productPics"/>
                </div>
                <div class="con">{{item.title}}</div>
                <div class="pri">
                  <div>{{item.exchangeScore}}积分</div>
                  <div>热门</div>
                </div>
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import Api from '@/api/customer-good'

  export default {
    components: {},
    created () {
      Api.viewpagerTo(response => {
        let status = response.data.code
        let body = response.data.data
        if (status === '200') {
          this.list = body
        } else {
          this.list = []
        }
      })
      this.requestList()
      setTimeout(() => {
        this.ani()
      }, 0)
    },
    data () {
      return {
        swiperOption1: {
          loop: true,
          speed: 900,
          notNextTick: true,
          autoplay: true,
          preloadImages: false,
          pagination: {
            el: '.swiper-pagination1',
            clickable: true
          },
          paginationClickable: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        list: [],
        lpzx: [],
        zszt: [],
        sqcy: [],
        wjqm: []
      }
    },
    methods: {
      requestList () {
        Api.list({type: 1}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.lpzx = body.map.lpzx
            this.zszt = body.map.zszt
            this.sqcy = body.map.sqcy
            this.wjqm = body.map.wjqm
          } else {
            this.lpzx = []
            this.zszt = []
            this.sqcy = []
            this.wjqm = []
          }
        })
      },
      skip (a) {
        this.$router.push(a)
      }
    }
  }
</script>

<style lang="scss">
  .banan>.swiper-container>.swiper-pagination> .swiper-pagination-bullet {
    background: #409EFF;
    margin: 0 10px;
  }
  .banan>.swiper-container>.swiper-pagination> .swiper-pagination-bullet-active {
    background: #333;
    margin: 0 5px;
  }
  .banan>.swiper-container1>.swiper-pagination1> .swiper-pagination-bullet {
    background: #fff;
    margin: 0 10px;
  }
  .banan>.swiper-container1>.swiper-pagination1> .swiper-pagination-bullet-active {
    background: #fff;
    margin: 0 5px;
  }
  .banan>.swiper-container1> .swiper-button-prev {
    width: 30px;
    height: 20px;
  }
  .banan>.swiper-container1> .swiper-button-next {
    width: 30px;
    height: 20px;
  }
</style>
<style scoped="scoped" lang="scss">
  @import '../../assets/styles/_env.scss';
  .shopping{
    min-height: 1000px;
    background: white;
    padding: 20px 28px 50px 28px;
    box-sizing: border-box;
    border: 1px solid $color-cut-line;
    .shopping-t{
      font-size: 16px;
      font-weight: bold;
      color: #085ECC;
    }
    .banan{
      // width: 954px;
      // height: 166px;
      margin: 20px 0;
      .wrapper1{
        width: 100%;
        // height: 166px;
        background: white;
        position: relative;
        .bar-img1 {
          width: 100%;
          // height: 166px;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
      .swiper-container1 {
        width: 100%;
        height: 166px;
        background: white;
        position: relative;
        .swiper-pagination1{
          position: absolute;
          bottom: 10px;
          left: 45%;
          right: 0;
          margin: auto;
          z-index: 10;
        }
        .bar-img1 {
          width: 100%;
          height: 166px;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .wrap{
      width: 100%;
      min-height: 320px;
      padding: 20px;
      box-sizing: border-box;
      border-bottom: 1px solid $color-cut-line;
      >.title{
        font-size: $font-h2;
        font-weight: bold;
        color: $color-black;
      }
      >.content{
        width: 100%;
        min-height: 300px;
        padding: 10px;
        box-sizing: border-box;
        overflow:hidden;
        zoom: 1;
        >ul{
          list-style: none;
          min-height: 300px;
          padding-top: 20px;
          box-sizing: border-box;
          >li{
            width: 175px;
            height: 260px;
            float: left;
            margin:13px 18px;
            border-radius:4px;
            cursor: pointer;
            &:hover{
              margin-top: -10px;
              margin-bottom: 30px;
              transition-duration: 0.5s;
              background:rgba(255,255,255,1);
              box-shadow:0px 5px 10px 0px rgba(162,170,181,0.25);
              -ms-box-shadow: 0px 5px 10px 0px rgba(162,170,181,0.25);
              -moz-box-shadow: 0px 5px 10px 0px rgba(162,170,181,0.25);
              -webkit-box-shadow: 0px 5px 10px 0px rgba(162,170,181,0.25);
              -o-box-shadow: 0px 5px 10px 0px rgba(162,170,181,0.25);
            }
            .pic{
              width: 100%;
              height: 160px;
              >img{
                width: 100%;
                height: 100%;
              }
            }
            .con{
              width: 100%;
              height: 40px;
              line-height: 40px;
              padding: 0 10px;
              box-sizing: border-box;
              font-size: 14px;
              color: #333;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
            .pri{
              width: 100%;
              height: 40px;
              line-height: 40px;
              padding: 0 10px;
              box-sizing: border-box;
              div:nth-child(1){
                float: left;
                font-size: 14px;
                color: #1770E6;
              }
              div:nth-child(2){
                width: 46px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                float: right;
                font-size: 14px;
                color: #1770E6;
                border: 1px solid #1770E6;
                border-radius: 2px;
                margin-top: 10px;
              }
            }
          }
          li:nth-child(5n+1){
            clear:both;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/client/ShoppingMall.vue